import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const ErrorContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '20px',
    backgroundColor: '#f5f5f5'
}));

const ErrorCard = styled(motion.div)(({ theme }) => ({
    maxWidth: '500px',
    padding: '2rem',
    borderRadius: '8px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center'
}));

const RetryButton = styled(Button)(({ theme }) => ({
    padding: '10px 20px',
    fontSize: '16px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginTop: theme.spacing(2),
    '&:hover': {
        backgroundColor: theme.palette.primary.dark,
    }
}));

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            retryCount: 0
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        if (error.toString().includes('persona data')) {
            this.setState({ hasError: false });
            return;
        }

        this.setState(prevState => ({
            retryCount: prevState.retryCount + 1
        }));

        console.error('Error:', error);
        console.error('Error Info:', errorInfo);
    }

    handleRetry = () => {
        this.setState({
            hasError: false,
            retryCount: 0
        });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <ErrorContainer>
                    <ErrorCard
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Typography variant="h4" gutterBottom color="error">
                            오류가 발생했습니다
                        </Typography>
                        <RetryButton
                            onClick={this.handleRetry}
                            component={motion.button}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            다시 시도하기
                        </RetryButton>
                    </ErrorCard>
                </ErrorContainer>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;